// extracted by mini-css-extract-plugin
export default {"has-spacing":"style_has-spacing__zSpjV","white":"style_white__MJ4UG"};